import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { cashFlowApi } from '../cash-flow.api';


export const useCashFlowPeriods = () => {
  const { data, isLoading, error } = cashFlowApi.useGetCashFlowPeriodsQuery();
  return {
    cashFlowPeriods: data,
    error: extractNestJsErrorMessage(error),
    isLoading
  };
};
